export default `
--icon-size-default: 14px;
--text-size-default: 14px;

// Smaller size
--text-size-xx-small: 8px;
--text-size-x-small: 10px;
--text-size-small: 12px;

// Larger size
--text-size-medium: 16px;
--text-size-large: 18px;

--text-size-login-into-h1: 24px;
--text-size-login-into-h2: 20px;

`;
